import styled from 'styled-components/macro';

const IconsWrapper = styled.div`
  *:not(:last-child) {
    margin-right: 0.5rem;
  }
`;

export default IconsWrapper;
